module.exports = __webpack_public_path__ + "static/media/invalid-icon.ae5136d4.svg";